import React from "react";
import PropTypes from "prop-types";
import { Box, Switch, Typography } from "@mui/material";
import "./ToggleSwitch.css";

const ToggleSwitch = ({ mainLabel, labelLeft, labelRight, checked, onChange }) => {
  return (
    <Box className="toggle-switch-wrapper" display="flex" alignItems="center" justifyContent="space-between">
      <Typography variant="body1" className="main-label">
        {mainLabel}:
      </Typography>
      <Box className="toggle-switch" display="flex" alignItems="center">
        <Typography variant="body2" className="toggle-label">
          {labelLeft}
        </Typography>
        <Switch
          checked={checked}
          onChange={onChange}
          color="primary"
          inputProps={{ "aria-label": `${labelLeft} / ${labelRight} switch` }}
        />
        <Typography variant="body2" className="toggle-label">
          {labelRight}
        </Typography>
      </Box>
    </Box>
  );
};

ToggleSwitch.propTypes = {
  mainLabel: PropTypes.string.isRequired,
  labelLeft: PropTypes.string.isRequired,
  labelRight: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ToggleSwitch;
